import React, { useState } from "react";
import "./Register_page.css"
function RegisterPage({setShowMessage, setMessage, setError}) {
  const [phoneNo, setPhoneNo] = useState('');
  const [otp, setOtp] = useState('');
  const [email, setEmail] = useState('');


  async function handleOTP(e){
    e.preventDefault();
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "body": {
            "action": "register",
            "username": phoneNo,
            "phone_number": phoneNo,
            "email": email || ""
          }
        }),
      });
      const data = await response.json();
      //console.log(data);
      if(data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203){
        setShowMessage(true);
        setMessage("OTP Sent Successfully");
        setError(false);
      }else{
        setShowMessage(true);
        setMessage("Failed to send OTP, please try again");
        setError(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleSubmit(e){
    e.preventDefault();
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "body": {
            "action": "validate_otp",
            "username": phoneNo,
            "phone_number": phoneNo,
            "otp": otp
          }
        }),
      });
      const data = await response.json();
      //console.log(data);
      if(data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203){
        setShowMessage(true);
        setMessage("Register Successfully, please login");
        setError(false);
      }else{
        setShowMessage(true);
        setMessage("Failed to register, please try again");
        setError(true);
      }
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <div className="register-page-form">
      <h2>Register</h2>
      <p>Create new account today to reap the benefits of a personalized shopping experience.</p>
      <div className='register-page-form-group'>
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className='register-page-form-group'>
        <label htmlFor="phone-no">Phone No.</label>
        <input
          type="number"
          id="phone-no"
          onChange={(e) => setPhoneNo(e.target.value)}
        />
      </div>
      <button className='register-page-form-button' disabled={(phoneNo && email)?false:true} onClick={handleOTP}>Send OTP</button>
      <div className='register-page-form-group'>
        <label htmlFor="otp">OTP</label>
        <input
          type="number"
          id="otp"
          onChange={(e) => setOtp(e.target.value)}
        />
      </div>
      <button className='register-page-form-button' disabled={(otp)?false:true} onClick={handleSubmit}>Register</button>
    </div>
  );
}

export default RegisterPage;